<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>

<!-- 入金／返金／振替（ラジオボタン）-->
<div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center ">
    <mat-radio-group name="registType" color="warn" (change)="onChangeRadio($event.value)"
        class="search-condition-radio-frame" [(ngModel)]="registType"
        style="position: relative;border: solid 1px rgba(117, 62, 62, 0.12); border-radius: 5px; padding-right: 1em; margin-top: 15px;">
        <mat-label
            style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
            登録種別</mat-label>
        <mat-radio-button class="radio-button-margin" [value]="['5', '01']"
            style="margin-bottom: 10px!important; margin-top: 10px;">SGKE020D(充当)「保留中(01)」</mat-radio-button>
        <mat-radio-button class="radio-button-margin" [value]="['5', '03']"
            style="margin-bottom: 10px!important; margin-top: 10px;">SGKE020D(充当)「充当確定(03)」</mat-radio-button>
    </mat-radio-group>
</div>

<div class="juto" *ngIf="registType=='5'">
    <app-sgke070d-regist [kinkoMno]="kinkoMno" [kinkoRrkno]="kinkoRrkno" [kinkoUpdateSrno]="kinkoUpdateSrno"
        [kinkoexUpdatesequencenumber]="kinkoexUpdatesequencenumber" [kinkoStatuscode]="kinkoStatuscode"
        (searchEmit)="search()" (msgEmit)="showMsg($event)" (clearMessageEmit)="clearErrorMsg()"></app-sgke070d-regist>
</div>